<script lang="ts">
	import type { CategoryMinData, ItemData, OrderData } from "@hitit/api";
	import { formatNumber } from "@hitit/utils";
	import { t } from "@hitit/hub/src/stores";
	import CategorySelectBox from "./CategorySelectBox.svelte";

	export let orderDTO: OrderData;
	export let storeItemMin: CategoryMinData[] = [];
	export let editmode = false;

	let categoryOpenControl: {
		instores: boolean[];
		togos: boolean[];
	} = { instores: [], togos: [] };
	let instores: ItemData[] = [];
	let togos: ItemData[] = [];

	function itemConvertSorted(orderDTO: OrderData) {
		let instore: ItemData[] = [];
		let togo: ItemData[] = [];
		if (orderDTO.itemDTOs) {
			orderDTO.itemDTOs.forEach((v, i) => {
				if (v.itemOrderType === "INSTORE") {
					instore.push(v);
				} else if (v.itemOrderType === "TOGO") {
					togo.push(v);
				}
			});
		} else {
			return [];
		}
		instores = instore.sort((a, b) => a.displaySort! - b.displaySort!);
		togos = togo.sort((a, b) => a.displaySort! - b.displaySort!);

		if (instores && togos) {
			categoryOpenControl.instores = new Array(instores.length).fill(false);
			categoryOpenControl.togos = new Array(togos.length).fill(false);
		}
	}

	function categoryTogoHandler(e: { detail: { index: number } }) {
		const index = e.detail.index;
		categoryOpenControl.togos = categoryOpenControl.togos.map((v, i) => {
			if (i === index) {
				categoryOpenControl.instores = categoryOpenControl.instores.map(
					(v) => (v = false)
				);
				return (v = !v);
			}
			return i !== index ? (v = false) : (v = true);
		});
	}

	function categoryInstoreHandler(e: { detail: { index: number } }) {
		const index = e.detail.index;
		categoryOpenControl.instores = categoryOpenControl.instores.map((v, i) => {
			if (i === index) {
				categoryOpenControl.togos = categoryOpenControl.togos.map(
					(v) => (v = false)
				);
				return (v = !v);
			}
			return i !== index ? (v = false) : (v = true);
		});
	}

	$: itemConvertSorted(orderDTO);
</script>

{#if togos}
	<div class="item-type-row">
		{$t("hub.order.item_order_type.TOGO")}
	</div>
	{#each togos as togo, index}
		<div class="row">
			<div class="col product">
				<CategorySelectBox
					value={togo.name}
					categorys={storeItemMin}
					editmode={editmode}
					index={index}
					on:CHANGE_CATEGORY={categoryTogoHandler}
					bind:categoryOpen={categoryOpenControl.togos[index]}
				/>
			</div>
			<div class="col price">
				<p>{formatNumber(togo.unitPrice)}</p>
			</div>
			<div class="col count">
				<p>{formatNumber(togo.quantity)}</p>
			</div>
			<div class="col total">
				<p>{formatNumber(togo.unitPrice * togo.quantity)}</p>
			</div>
		</div>
		{#each togo.optionDTOs || [] as optionDTO}
			{#each optionDTO.optionItemDTOs || [] as optionItemDTO}
				<div class="row option">
					<div class="col product">
						<p>{`- ${optionItemDTO.name}`}</p>
					</div>
					<div class="col price">
						<p>{formatNumber(optionItemDTO.unitPrice)}</p>
					</div>
					<div class="col count">
						<p>{formatNumber(optionItemDTO.quantity)}</p>
					</div>
					<div class="col total">
						<p>
							{formatNumber(optionItemDTO.unitPrice * optionItemDTO.quantity)}
						</p>
					</div>
				</div>
				{#if optionItemDTO.discount}
					<div class="row option optionDiscount">
						<div class="col product">
							{$t("global.Individual_Discount")}
						</div>
						<div class="col price" />
						<div class="col count" />
						<div class="col total">
							-{formatNumber(optionItemDTO.discount)}
						</div>
					</div>
				{/if}
			{/each}
		{/each}
		{#if togo.discount}
			<div class="row option itemDiscount">
				<div class="col product">
					{$t("global.Individual_Discount")}
				</div>
				<div class="col price" />
				<div class="col count" />
				<div class="col total">-{formatNumber(togo.discount)}</div>
			</div>
		{/if}
	{/each}
{/if}
{#if instores}
	<div class="item-type-row">
		{$t("hub.order.item_order_type.INSTORE")}
	</div>
	{#each instores as instore, index}
		<div class="row">
			<div class="col product">
				<CategorySelectBox
					value={instore.name}
					categorys={storeItemMin}
					editmode={editmode}
					index={index}
					on:CHANGE_CATEGORY={categoryInstoreHandler}
					bind:categoryOpen={categoryOpenControl.instores[index]}
				/>
			</div>
			<div class="col price">
				<p>{formatNumber(instore.unitPrice)}</p>
			</div>
			<div class="col count">
				<p>{formatNumber(instore.quantity)}</p>
			</div>
			<div class="col total">
				<p>{formatNumber(instore.unitPrice * instore.quantity)}</p>
			</div>
		</div>
		{#each instore.optionDTOs || [] as optionDTO}
			{#each optionDTO.optionItemDTOs || [] as optionItemDTO}
				<div class="row option">
					<div class="col product">
						<p>{`- ${optionItemDTO.name}`}</p>
					</div>
					<div class="col price">
						<p>{formatNumber(optionItemDTO.unitPrice)}</p>
					</div>
					<div class="col count">
						<p>{formatNumber(optionItemDTO.quantity)}</p>
					</div>
					<div class="col total">
						<p>
							{formatNumber(optionItemDTO.unitPrice * optionItemDTO.quantity)}
						</p>
					</div>
				</div>
				{#if optionItemDTO.discount}
					<div class="row option optionDiscount">
						<div class="col product">
							{$t("global.Individual_Discount")}
						</div>
						<div class="col price" />
						<div class="col count" />
						<div class="col total">
							-{formatNumber(optionItemDTO.discount)}
						</div>
					</div>
				{/if}
			{/each}
		{/each}
		{#if instore.discount}
			<div class="row option itemDiscount">
				<div class="col product">
					{$t("global.Individual_Discount")}
				</div>
				<div class="col price" />
				<div class="col count" />
				<div class="col total">-{formatNumber(instore.discount)}</div>
			</div>
		{/if}
	{/each}
{/if}

<style lang="scss">
	@import "../../../variables.scss";
	.item-type-row {
		@include appleAdjustTextForSize(16);
		font-weight: 550;
		color: #46474b;
	}

	.row {
		display: flex;
		p {
			word-break: break-all;
		}
		.col {
			word-wrap: break-word;
			text-align: center;

			&.product {
				text-align: start;
			}
			&.total {
				text-align: end;
			}
		}
	}
	.row {
		gap: 10px;
		&.option {
			font-size: 0.875rem;
			color: #6d6f76;
		}

		.col {
			display: flex;
			justify-content: center;
		}

		.product {
			justify-content: flex-start;
			flex-grow: 276;
			max-width: calc((100% - 5px) * (276 / 619));
		}
		.price {
			flex-grow: 144;
			max-width: calc((100% - 50px) * (144 / 619));
		}
		.count {
			flex-grow: 55;
			max-width: calc((100% - 55px) * (55 / 619));
		}
		.total {
			justify-content: flex-end;
			flex-grow: 144;
			max-width: calc((100% - 50px) * (144 / 619));
		}
	}

	@include DesktopSize {
		.item-type-row {
			@include appleAdjustTextForSize(16, false);
		}
		.row {
			&.option {
				font-size: 1rem;
			}

			.product {
				justify-content: flex-start;
				flex-grow: 211;
				max-width: calc((100% - 30px) * (211 / 619));
			}
			.price {
				flex-grow: 164;
				max-width: calc((100% - 30px) * (164 / 619));
			}
			.count {
				flex-grow: 80;
				max-width: calc((100% - 30px) * (80 / 619));
			}
			.total {
				justify-content: flex-end;
				flex-grow: 164;
				max-width: calc((100% - 30px) * (164 / 619));
			}

			p {
				width: 100%;
			}
		}
	}
</style>
